// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__CwrXl","button":"Tile_button__NPDt1","active":"Tile_active__lYnua","disabled":"Tile_disabled__473Ys","card":"Tile_card__WvKa4","label":"Tile_label__UgdAP"};